import React,{Component} from 'react';
import Slider from "react-slick";
import grid1 from './../../images/testimonials/pic2.jpg';
import grid2 from './../../images/testimonials/pic4.jpg';
import grid3 from './../../images/testimonials/pic5.jpg';


const latestBlog = [
	{ image: grid1, name: "Soni Singh ", desc: "It is a beautiful place where all kids meet and start their learning and very thanks to all teachers to teach them with full of fun. " },
	{ image: grid2, name: "Sandesh Gala ", desc: "It is a pre-school that focus on the holistic development of the children and has a competent and supportive teaching staff. " },
	{ image: grid3, name: "Rahul Anand", desc: "Brilliant pre-school ... has its own sports facilities for children in addition to educational curriculum for their overall growth ..." },

]
class TestiMonialSlider extends Component{	
	constructor(props) {
		super(props);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
	}
	next() {
		this.slider.slickNext();
	}
	previous() {
		this.slider.slickPrev();
	}
	render(){
		var settings = {		
			arrows: false,
            slidesToShow: 1,			
            infinite: true,
			autoplay: true,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 1,
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 1,
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1,
				  }
				}
			]
        };
		return(
			<>	
				<div className="sprite-nav">
					<Slider className="client-carousel owl-carousel owl-theme  " ref={c => (this.slider = c)} {...settings}>
						{latestBlog.map((item, index) => (
							<div className="item" key={index}>
								<div className="client-box">
									<div className="testimonial-detail clearfix">
										<div className="testimonial-pic radius">
											<img src={item.image} width="100" height="100" alt="" />
										</div>
										<h5 className="testimonial-name m-t0 m-b5">{item.name}</h5> 
										<span>Parent</span> 
									</div>
									<div className="testimonial-text">
										<p>{item.desc}</p>
									</div>
								</div>	
							</div>
						))}	
					</Slider>		
					<div className="owl-nav" style={{ textAlign: "center" }}>
						<div className=" owl-prev " onClick={this.previous}/>
						<div className="owl-next " onClick={this.next}/>
					</div>
				</div>	
			</>	
		)
	}
}
export default TestiMonialSlider;